import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@azim-crm/icons";
import styles from "./Page.module.css";
/**
 * Wrapper de página — flex-column, altura 100%, min-width 0.
 */
export function Page({ children, className, style }) {
    return (_jsx("div", { className: [styles.page, className ?? ""].filter(Boolean).join(" "), style: style, children: children }));
}
/**
 * Cabeçalho fixo de página com eyebrow, título, subtítulo e ações.
 */
export function PageHeader({ title, eyebrow, sub, icon, actions, dense = false, className, }) {
    const padding = dense ? "16px 24px 16px" : "20px 28px 20px";
    return (_jsx("header", { className: [styles.header, className ?? ""].filter(Boolean).join(" "), style: { padding }, children: _jsxs("div", { className: styles.headerInner, children: [_jsxs("div", { className: styles.headerMeta, children: [eyebrow && _jsx("div", { className: styles.eyebrow, children: eyebrow }), _jsxs("div", { className: styles.titleRow, children: [icon && (_jsx("span", { className: styles.titleIcon, children: _jsx(Icon, { name: icon, size: 22 }) })), _jsx("h1", { className: styles.title, children: title })] }), sub && _jsx("p", { className: styles.sub, children: sub })] }), actions && _jsx("div", { className: styles.headerActions, children: actions })] }) }));
}
/**
 * Barra de ferramentas (filtros, seletor de view, etc.).
 */
export function Toolbar({ left, right, className, style }) {
    return (_jsxs("div", { className: [styles.toolbar, className ?? ""].filter(Boolean).join(" "), style: { padding: "12px 28px", ...style }, children: [_jsx("div", { className: styles.toolbarLeft, children: left }), right && _jsx("div", { className: styles.toolbarRight, children: right })] }));
}
/**
 * Área de conteúdo scrollável da página.
 * Usa <main> para satisfazer WCAG 2.1 AA (landmark region, axe: region rule).
 */
export function Body({ children, pad = true, className, style }) {
    return (_jsx("main", { className: [styles.body, pad ? styles.bodyPadded : "", className ?? ""]
            .filter(Boolean)
            .join(" "), style: style, children: children }));
}
//# sourceMappingURL=Page.js.map